import React from "react";
import { PUBLICATION_PERMISSION, PUBLICATION_REAUTHORIZE, REVIEWS_WORK_WITHOUT_CHECKS } from "../copy/decisionReviewCopy";
import { publicationView } from "./reviewDisplay";
import InlineAlert from "../ui/InlineAlert";

export default function ReviewPublicationStatus({ review, capability, canRetry, onRetry, onReauthorize }) {
  const view = publicationView(review, capability);
  const reviewCompleted = review?.status === "completed";
  let detail = view.label;
  if (view.id === "permission") detail = PUBLICATION_REAUTHORIZE;
  else if (view.id === "published") detail = "Review completed. GitHub Check published.";
  else if (view.id === "disabled") detail = "Review completed. GitHub Check publication is turned off.";
  else if (view.id === "reauth") detail = capability?.message || "Review completed. Connect the RenderRepo GitHub App to publish this result on GitHub.";
  else if (view.id === "failed") detail = review?.publication?.errorMessage || PUBLICATION_PERMISSION;
  else if (reviewCompleted && !capability?.checksWrite) detail = REVIEWS_WORK_WITHOUT_CHECKS;

  return (
    <InlineAlert testId="decision-review-publication">
      <p>
        <span className="rr-sr">GitHub publication. </span>
        {detail}
      </p>
      {reviewCompleted ? <p>The review itself is completed.</p> : null}
      <div className="rr-actions">
        {onReauthorize && (view.id === "permission" || view.id === "reauth") ? (
          <button type="button" className="rr-text-button" onClick={onReauthorize}>
            Enable GitHub Checks
          </button>
        ) : null}
        {canRetry && view.id !== "published" && review?.currentState !== "stale" && reviewCompleted ? (
          <button type="button" className="rr-text-button" data-testid="decision-review-retry" onClick={onRetry}>
            Retry publication
          </button>
        ) : null}
      </div>
    </InlineAlert>
  );
}
